window.addEventListener('scroll', function() {
    const header = document.getElementById('wrapper-navbar');
    const headerHeight = header.offsetHeight;
    const logoImage = document.querySelector('.custom-logo-link img');
    const site_stylesheet_directory_uri = "/wp-content/themes/understrap-child/images";

    if (window.scrollY >= headerHeight) {
        header.classList.remove('bg-transparent');
        header.classList.add('bg-white');
        logoImage.src = site_stylesheet_directory_uri + "/Villa-Teny-dark.png";
    } else {
        header.classList.remove('bg-white');
        header.classList.add('bg-transparent');
        logoImage.src = site_stylesheet_directory_uri + "/Villa-Teny-light.png";
    }
});